import React from 'react'
import styled from 'styled-components'
import translate from '../../../../../../modules/translate'
import WeatherIcon from '../../../../../../topics/Weather/components/IconWeather/images/icon_c.svg'
import { namedRoute } from '../../../../../../modules/named-router'
import LinkNavTool from './components/LinkNavTool'
import LoginNavTool from './components/LoginNavTool'
import SvgSplus from '../../../../../../components/Icon/keys/iconKeys/images/Splus'

const Wrapper = styled.div`
  display: flex;
  color: ${(props) => props.theme.color.textSecondary};
  font-size: ${(props) => props.theme.fontSize.small};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.small};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.small};
  }
  align-items: center;
`

const StyledWeatherIcon = styled.img`
  display: block;
  height: 1.2em;
  width: 2.4em;
  min-width: 35px;
`

const StyledSplus = styled(SvgSplus)`
  height: 21px;
  width: 21px;
`
//IMPORTANT change max-width, min-width (SecondTopCol in Header/index.js) if you want to add Icons to the NavTools

const NavTools = ({ loggedIn, ...props }) => {
  return (
    <Wrapper {...props}>
      <LinkNavTool to={namedRoute('weather').path}>
        {translate('weather')}
        <StyledWeatherIcon src={WeatherIcon} />
      </LinkNavTool>
      <LoginNavTool />
      <LinkNavTool to={namedRoute('department.splus').path}>
        <StyledSplus />
      </LinkNavTool>
    </Wrapper>
  )
}

export default NavTools
export { Wrapper as Wrapper0NavTools }
